<template>
  <link rel="stylesheet" href="https://use.typekit.net/vry6bfi.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.2.0/css/font-awesome.min.css" integrity="sha512-ZfKn7az0YmtPUojZnRXO4CUdt3pn+ogBAyGbqGplrCIR5B/tQwPGtF2q29t+zQj6mC/20w4sSl0cF5F3r0HKSQ==" crossorigin="anonymous" referrerpolicy="no-referrer" />
  <div>
    
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
/* Estilos globais */
body,
p,
a,
button,
div,
input,
textarea,
select{
  font-family: "Arboria";
}
:root{
  --green:#39E241;
  --violet:#B49CFF;
  --black:#1e1e1e;
}
</style>
